import { render } from "./App.vue?vue&type=template&id=c506e5ae"
const script = {}

import "./App.vue?vue&type=style&index=0&id=c506e5ae&lang=css"

import exportComponent from "/home/vsts/work/1/s/share.filevaultcore.com/share.filevaultcore.com/share.filevaultcore.spa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__